"use client";

import React, { useMemo } from "react";
import DatadogLogsInit from "./init-logs";
import DatadogRUMInit from "./init-rum";
import {
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_SERVICE,
  DATADOG_SITE
} from "config";

export const DatadogInit = () => {
  const datadogConfigured = useMemo(() => {
    return (
      DATADOG_APPLICATION_ID &&
      DATADOG_CLIENT_TOKEN &&
      DATADOG_SERVICE &&
      DATADOG_SITE
    );
  }, []);
  return (
    datadogConfigured && (
      <React.Fragment>
        <DatadogLogsInit />
        <DatadogRUMInit />
      </React.Fragment>
    )
  );
};
